<template lang="pug">
  .link-w-arrow.text-15.md-text-17.font-unica.leading-none(class="flex items-center pt-12 px-15 pb-10 border hover-text-blue hover-border-blue trans-fast")
    arrow-down-right.mr-8(style="width:1.7rem; transform: translateY(-.1rem)")
    slot
</template>

<script>
import ArrowDownRight from '@/components/Icons/ArrowDownRight'
import wpLink from '@/components/WPLink'
export default {
  name: 'LinkWithArrow',
  components: { ArrowDownRight, wpLink },
  props: ['link', 'inheritFontSize']
}
</script>

<style>
</style>
